import { useTranslation } from 'react-i18next';
import {
  UsersIcon,
  SunIcon,
  CheckCircleIcon,
  StarIcon,
  EyeIcon,
  ShieldCheckIcon,
} from "@heroicons/react/24/outline";

const timeline = [
  {
    id: 1,
    content: `Зуны болон өвлийн ээлжтэйгээр хүүхдүүдийг хүлээн авx бөгөөд өвлийн ээлжид "Харшийн сүлд модны наадам" хийдэг болсон.`,
    href: "#",
    date: "1978-1981",
    iconBackground: "bg-gray-400",
  },
  {
    id: 2,
    content: `Пионерын байгууллагыг дэмждэг зуслан болж, анги хамт олны болон өдрийн амралтын үйлчилгээ нэвтрүүлсэн.`,
    href: "#",
    date: "1990-1992",
    iconBackground: "bg-blue-500",
  },
  {
    id: 3,
    content:
      "Хурал, симпозиум, аварга шалгаруулах тэмцээн, наадам зэрэг төрөл бүрийн арга хэмжээг зохион байгуулж. Сургуулийн барилгыг \u201cХөгжил мэдээллийн ордон\u201d болгож шинэчлэв.",
    href: "#",
    date: "1998-2005 ",
    iconBackground: "bg-green-500",
  },
  {
    id: 4,
    content:
      "Зуслангийн үйл ажиллагааны стандартыг боловсруулж, урлагийн наадам, зөвлөгөөний хөтөлбөр зэрэг төрөл бүрийн арга хэмжээг зохион байгуулав. Нээлттэй цахим зуслан хөтөлбөр хэрэгжиж эхлэв.",
    href: "#",
    date: "2006-2010",
    iconBackground: "bg-blue-500",
  },
  {
    id: 5,
    content:
      "Олон улсын бага хурал, театрын нээлт, Ази Номхон далайн скаутуудын Жембори зэрэг төрөл бүрийн арга хэмжээг зохион байгуулсан. Олон улсын хүүхдийн \u201cНайрамдал\u201d төвийн нэрийг \u201cОлон улсын хүүхдийн \u201cНайрамдал\u201d цогцолбор болгон шинэчлэн өргөтгөн, уламжлалт харилцаагаа дахин сэргээж ОХУ-ын \u201cАртек\u201d, Орлёнок зуслантай  хамтарж ажиллах гэрээ байгууллаа",
    href: "#",
    date: "2011-2020 ",
    iconBackground: "bg-green-500",
  },
];


const people = [
  {
    name: "Одод",
    bio: "Скандинавийн орнуудын барилга байгууламжийн хэв маягийг хадгалсан . Хадаас ороогүй оньсон чагтлах аргаар баригдсан .Учир нь уг орон маш чийглэг учраас хадаас зэв болж модоо идэн нурах аюултай учраас төмөрлөг зүйл бага ордог.",
    imageUrl: "/odod.png",
  },
  {
    name: "Солонго",
    imageUrl: "/solongo.png",
    bio: "Зүүн өмнөд ази буюу Вьетнам үндэсний барилгын хэв маягаар баригдсан. Социалист орнуудаас архитекторчид урьсны дагуу Вьетнам улс зураг төслөө илгээсэн. Барилга байшингууд нь ихэвчлэн усан дээр баригдсан байдгаас доороо урт модон тулгууртай байдаг.",
  },
  {
    name: "Сансар",
    imageUrl: "/sansar.png",
    bio: "Эртний Орос тосгоны байшин мэт сэтгэгдэл төрүүлэхээр баригдсан. Эртний Оросууд цонхны ойролцоо дээвэр, ханаа модоор янз бүрийн сийлбэр, хээ угалзуудын хамт хийн чамин маяг оруулдаг байсан. Мөн сүмийн маягтай цамхаг дээр нь зоосон тахиа үүнд хамаарна.",
  },
  {
    name: "Туяа",
    imageUrl: "/tuya.png",
    bio: "Болгар байшин нь нар тусах газар болгон буюу хана болгондоо нарны гэрэл тусгах, агаар оруулах зориулалттай цонх, дотор гаднагүй шавардлагатай байдгаараа онцлогтой билээ.",
  },
  {
    name: "Оч",
    imageUrl: "/och.png",
    bio: "Геометрийн дүрсүүд орсон хурц тод өнгө, 2 давхар баригдсан.",
  },
  {
    name: "Нарлаг",
    imageUrl: "/narlag.png",
    bio: "Монгол загварын байшин эртний сүм дуганы оройн ганжир, чөлөөт цагийн танхим нь Монгол гэр шиг дугуй хэлбэртэй хийгдсэн нь барилгын хийцтэй.",
  },
  {
    name: "Сэтгэмж",
    imageUrl: "/setgemj.png",
    bio: "Өмнө нь ОУХНЦ-н захиргаа, эмнэлэг үйл ажиллагаагаа явуулдаг байгаад Сэтгэмж бүлэг нэртэй болсон.",
  },
  {
    name: "Өвлийн амралтын төв байр",
    imageUrl: "/owliin.png",
    bio: "Өвлийн амралтын төв байр нь Ирээдүй, Мичид , Оргил, Сонор, Нөхөрлөл ,Ундраа гэсэн нийт 6 бүлэгтэй. Бүлгээсээ хамаарч 1 өрөөнд 4-10 хүүхэд амрах бөгөөд нийт 260 хүүхэд хүлээн авах хүчин чадалтай.",
  },
];

export default function About() {
  const { t } = useTranslation();

  const features = [
    {
      name: t('about.mission'),
      description: t('about.missionDesc'),
      icon: CheckCircleIcon,
    },
    {
      name: t('about.values'),
      description: t('about.valuesDesc'),
      icon: StarIcon,
    },
    {
      name: t('about.vision'),
      description: t('about.visionDesc'),
      icon: EyeIcon,
    },
  ];

  const featuresContent = [
    {
      name: t('about.qualityPolicy'),
      description: t('about.qualityPolicyDesc'),
      href: "#",
      icon: ShieldCheckIcon,
    },
    {
      name: t('about.envPolicy'),
      description: t('about.envPolicyDesc'),
      href: "#",
      icon: SunIcon,
    },
  ];

  return (
    <>
      {/* Section 1 - Director (Dark Hero) */}
      <section className="relative overflow-hidden bg-[#0a1628] -mt-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-secondary-500/15 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-warm-500/10 blur-[100px]" />
        </div>
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative min-h-screen pt-40 pb-16 sm:pt-48 sm:pb-20">
          <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
            <div className="grid lg:grid-cols-2 gap-12 items-center animate-fade-in">
              <div className="order-2 lg:order-1">
                <div className="bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl p-8 md:p-12">
                  <div className="flex items-center gap-3 mb-6">
                    <h2 className="text-2xl sm:text-3xl font-bold text-white">
                      {t('about.directorGreeting')}
                    </h2>
                  </div>
                  <div className="space-y-6 text-slate-300 leading-relaxed text-base sm:text-lg">
                    <p>
                      {t('about.directorP1')}
                    </p>
                    <p>
                      {t('about.directorP2')}
                    </p>
                    <p>
                      {t('about.directorP3')}
                    </p>
                    <p className="font-semibold text-primary-400">
                      {t('about.directorP4')}
                    </p>
                  </div>
                </div>
              </div>
              <div className="order-1 lg:order-2 text-center lg:text-left animate-slide-up">
                <div className="relative inline-block">
                  <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10 group">
                    <img
                      className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500"
                      src="/otgonbat.png"
                      alt="Ерөнхий захирал"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  </div>
                </div>
                <figcaption className="mt-6">
                  <div className="inline-block bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl px-6 py-4">
                    <div className="text-sm text-slate-400 mb-1">{t('about.directorTitle')}</div>
                    <div className="font-bold text-white text-xl">
                      {t('about.directorName')}
                    </div>
                  </div>
                </figcaption>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2 - Introduction (White) */}
      <div className="bg-white py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1 animate-slide-up">
              <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg">
                <div className="flex items-center gap-3 mb-6">
                  <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900">
                    {t('about.introTitle')}
                  </h2>
                </div>
                <p className="text-lg leading-8 text-neutral-600 mb-8">
                  {t('about.introDescription')}
                </p>
                <dl className="space-y-6">
                  {features.map((feature, index) => {
                    const featureBg = ['bg-primary-50', 'bg-secondary-50', 'bg-warm-50'][index % 3];
                    const featureIconBg = ['bg-primary-600', 'bg-secondary-600', 'bg-warm-600'][index % 3];
                    return (
                    <div
                      key={feature.name}
                      className={`relative pl-12 ${featureBg} rounded-xl p-4`}
                      style={{ animationDelay: `${index * 0.1}s` }}
                    >
                      <div className="absolute left-4 top-4">
                        <div className={`w-10 h-10 rounded-xl ${featureIconBg} flex items-center justify-center shadow-md`}>
                          <feature.icon className="h-5 w-5 text-white" aria-hidden="true" />
                        </div>
                      </div>
                      <dt className="font-bold text-lg text-neutral-900 mb-2">
                        {feature.name}
                      </dt>
                      <dd className="text-neutral-600 leading-relaxed">{feature.description}</dd>
                    </div>
                    );
                  })}
                </dl>
              </div>
            </div>
            <div className="order-1 lg:order-2 animate-scale-in">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
                <img
                  src="/nairamdal-image.jpg"
                  alt="Найрамдал цогцолбор"
                  className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500"
                  width={2432}
                  height={1442}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3 - Policies (Dark) */}
      <div className="relative overflow-hidden bg-[#0a1628]">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-secondary-500/15 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-warm-500/10 blur-[100px]" />
        </div>
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative py-16 sm:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="section-header text-3xl sm:text-4xl font-bold text-white mb-4">
                {t('about.policyTitle')}
              </h2>
            </div>
            <div className="grid lg:grid-cols-2 gap-8">
              {featuresContent.map((feature, index) => {
                const iconGradient = ['from-secondary-500 to-secondary-600', 'from-warm-500 to-warm-600'][index % 2];
                return (
                <div
                  key={feature.name}
                  className="bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/[0.08] transform hover:-translate-y-2 transition-all duration-300 animate-slide-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="flex items-center gap-4 mb-6">
                    <div className={`flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br ${iconGradient} shadow-md`}>
                      <feature.icon className="h-7 w-7 text-white" aria-hidden="true" />
                    </div>
                    <dt className="text-xl font-bold leading-7 text-white">
                      {feature.name}
                    </dt>
                  </div>
                  <dd className="text-base leading-7 text-slate-400">
                    <p>{feature.description}</p>
                  </dd>
                </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Section 4 - Timeline (White) */}
      <div className="bg-white py-16 sm:py-24 relative overflow-hidden">
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 animate-fade-in">
            <h2 className="section-header text-3xl sm:text-4xl md:text-5xl font-bold text-neutral-900 mb-4">
              {t('about.timelineTitle')}
            </h2>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div className="space-y-8 animate-slide-up">
              {timeline.map((event, eventIdx) => (
                <div
                  key={event.id}
                  className="relative"
                  style={{ animationDelay: `${eventIdx * 0.1}s` }}
                >
                  <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300">
                    <div className="flex gap-4">
                      <div className="flex-shrink-0">
                        <div className="w-12 h-12 rounded-xl bg-primary-600 flex items-center justify-center shadow-md">
                          <span className="text-white font-bold">{eventIdx + 1}</span>
                        </div>
                        {eventIdx !== timeline.length - 1 && (
                          <div className="absolute left-6 top-16 w-0.5 h-full bg-primary-300"></div>
                        )}
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                          <p className="text-lg font-bold text-primary-600">{event.date}</p>
                        </div>
                        <p className="text-neutral-600 leading-relaxed">{event.content}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="hidden lg:grid grid-cols-3 gap-4 animate-scale-in">
              {['/Rectangle_37.png', '/Rectangle_38.png', '/Rectangle_39.png', '/Rectangle_41.png', '/Rectangle_42.png'].map((img, idx) => (
                <div
                  key={idx}
                  className="relative rounded-2xl overflow-hidden shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                  style={{ animationDelay: `${idx * 0.1}s` }}
                >
                  <img
                    src={img}
                    alt=""
                    className="aspect-[2/3] w-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Section 5 - Groups (Dark) */}
      <div className="relative overflow-hidden bg-[#0a1628]">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-warm-500/15 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-secondary-500/10 blur-[100px]" />
        </div>
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative py-16 sm:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 animate-fade-in">
              <h2 className="section-header text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
                {t('about.groupsTitle')}
              </h2>
              <p className="mt-4 text-lg leading-8 text-slate-400 max-w-3xl mx-auto">
                {t('about.groupsDescription')}
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {people.map((person, index) => {
                const hoverColor = ['group-hover:text-primary-400', 'group-hover:text-secondary-400', 'group-hover:text-warm-400', 'group-hover:text-accent-400'][index % 4];
                return (
                <div
                  key={person.name}
                  className="bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl overflow-hidden hover:bg-white/[0.08] transform hover:-translate-y-2 transition-all duration-300 group animate-slide-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="relative overflow-hidden">
                    <img
                      className="aspect-[4/5] w-full object-cover group-hover:scale-110 transition-transform duration-500"
                      src={person.imageUrl}
                      alt={person.name}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  </div>
                  <div className="p-6">
                    <h3 className={`text-xl font-bold leading-8 tracking-tight text-white mb-3 ${hoverColor} transition-colors`}>
                      {person.name}
                    </h3>
                    <p className="text-base leading-7 text-slate-400 line-clamp-4">
                      {person.bio}
                    </p>
                  </div>
                </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
